/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import { createStore } from "vuex";

// Plugin Vuex Persistance
//import { createVuexPersistance } from './vuex-persistance-plugin';

// Global
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

// Module
import context from "./context/module-context";
import auth from "./auth/module-auth";
import asset from "./module-asset";
import organizationUnit from "./module-organization-unit";
import provider from "./module-provider";
import assetType from "./module-asset-type";
import assetCategory from "./module-asset-category";
import layoutTemplate from "./module-layout-template";
import organizationUnitType from "./module-organization-unit-type";
import location from "./module-location";
import pickList from "./dictionary/module-pick-list";
import jobposition from "./module-job-position";
import jobtitle from "./module-job-title";
import jobPositionAsset from "./module-job-position-asset";
import role from "./module-role";
import employee from "./module-employee";
import employeestatus from "./module-employee-status";
import report from "./report/module-report";
import userSetting from "./user-setting/module-user-setting";
import user from "./module-user";
import identify from "./module-identify";
import customer from "./module-customer";
import userJoinRole from "./module-user-join-role";
import sysoption from "./module-dboption";
import auditinglog from "./module-auditing-log";
// import tally from './module-tally';
import allocationReduceEmployee from "./module-allocation-reduce-employee";
import allocationReduceDepartment from "./module-allocation-reduce-department";
import allocationReduceLocation from "./module-allocation-reduce-location";
import audit from "./module-audit";
import usageHistory from "./module-usage-history";
import schedule from "./module-schedule";
import moduleprocess from "./module-process";
import moduleAccountObjectGroup from "./module-account-object-group";
import transfer from "./module-transfer";
import template from "./module-template";
import assetBalance from "./module-asset-balance";
import dashboard from "./module-dashboard";
import option from "./module-option";
import refund from "./module-refund";
import refunds from "./refund/module-refund";

import transactions from "./module-transaction";
import transactioncontrol from "./module-transactioncontrol";
import paymentlink from "./module-paymentlink";
import revenuemanagement from "./revenuemanagement/module-revenue-management";
import collectionperiod from "./revenuemanagement/module-collection-period";
import customercontacts from "./customercontacts/module-customer-contacts";
import transactionControlReport from "./module-transactioncontrolreport";
import merchantTransactionControl from "./merchanttransactioncontrol/module-merchant-transaction-control";
import reportControl from "./merchanttransactioncontrol/module-report-control";
import merchantTransactionControlTransaction from "./merchanttransactioncontrol/module-merchant-transaction-control-transaction";
import embedPaymentDemoMarketing from "./module-embedpaymentdemomarketing";
import notifications from "./notifications/moduleNotifications";

// Init instance of store
const store = createStore({
  // plugins:
  // 	process.env.NODE_ENV !== 'production'
  // 		? [createLogger(), createVuexPersistance()]
  // 		: [createVuexPersistance()],
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth,
    asset,
    context,
    organizationUnit,
    assetType,
    assetCategory,
    layoutTemplate,
    organizationUnitType,
    location,
    provider,
    pickList,
    jobposition,
    jobtitle,
    jobPositionAsset,
    role,
    user,
    customer,
    sysoption,
    employee,
    employeestatus,
    report,
    userSetting,
    auditinglog,
    allocationReduceEmployee,
    allocationReduceDepartment,
    allocationReduceLocation,
    audit,
    usageHistory,
    schedule,
    moduleprocess,
    moduleAccountObjectGroup,
    transfer,
    template,
    assetBalance,
    dashboard,
    option,
    userJoinRole,
    refund,
    refunds,
    transactions,
    transactioncontrol,
    paymentlink,
    revenuemanagement,
    collectionperiod,
    customercontacts,
    transactionControlReport,
    merchantTransactionControl,
    reportControl,
    merchantTransactionControlTransaction,
    embedPaymentDemoMarketing,
    notifications,
  },
  strict: false,
});

export default store;
